import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Panel } from '~/eds/src/components/Panel/Panel';
import { Tab } from '~/eds/src/types/Tab';

import { EnrichedGroupNode } from '../helpers/NodeEnricher/NodeEnricher';
import { TreeBrowserNode } from '../helpers/TreeBrowser/types';
import { GroupMembership } from './GroupMembership';

export const messages = defineMessages({
  groupsTab: {
    id: 'TicketDetailPanel.groupsTab',
    defaultMessage: 'Groups',
    description: 'Tab label for groups',
  },
  panelTitle: {
    id: 'WorkflowGroupDetailPage.panelTitle',
    defaultMessage: 'Node Details',
    description: 'Title for the node details panel',
  },
  nameLabel: {
    id: 'WorkflowGroupDetailPage.nameLabel',
    defaultMessage: 'Name',
    description: 'Label for node name field',
  },
  typeLabel: {
    id: 'WorkflowGroupDetailPage.typeLabel',
    defaultMessage: 'Item Type',
    description: 'Label for node type field',
  },
  idLabel: {
    id: 'WorkflowGroupDetailPage.idLabel',
    defaultMessage: 'ID',
    description: 'Label for node ID field',
  },
});

interface TicketDetailPanelProps {
  onClose: () => void;
  ticket?: TreeBrowserNode<EnrichedGroupNode>;
  currentGroup?: string;
}

export const TicketDetailPanel = ({
  onClose,
  ticket,
  currentGroup,
}: TicketDetailPanelProps) => {
  const { formatMessage } = useIntl();

  const tabs: Tab[] = useMemo(
    () =>
      ticket
        ? [
            {
              label: formatMessage(messages.groupsTab),
              value: 'groups',
              panel: (
                <GroupMembership
                  currentGroup={currentGroup}
                  resourceType="ticket"
                  resourceId={ticket.attributes.resourceId}
                />
              ),
            },
          ]
        : [],
    [currentGroup, ticket],
  );

  if (!ticket) {
    return null;
  }

  return (
    <Panel
      animate
      mode="floating"
      position="right"
      title={ticket.enrichedFields?.name ?? formatMessage(messages.panelTitle)}
      width="m"
      tabs={{
        selectedTab: 'groups',
        onSelectTab: () => {},
        enableContentPadding: false,
        tabs,
      }}
      hidden={{
        isHidden: false,
        onHide: onClose,
      }}
    ></Panel>
  );
};
